/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderRefundResponsibility } from './OrderRefundResponsibility';
import {
    OrderRefundResponsibilityFromJSON,
    OrderRefundResponsibilityFromJSONTyped,
    OrderRefundResponsibilityToJSON,
    OrderRefundResponsibilityToJSONTyped,
} from './OrderRefundResponsibility';
import type { OrderRefundReason } from './OrderRefundReason';
import {
    OrderRefundReasonFromJSON,
    OrderRefundReasonFromJSONTyped,
    OrderRefundReasonToJSON,
    OrderRefundReasonToJSONTyped,
} from './OrderRefundReason';

/**
 * 
 * @export
 * @interface OrderRefundBody
 */
export interface OrderRefundBody {
    /**
     * 
     * @type {OrderRefundReason}
     * @memberof OrderRefundBody
     */
    reason?: OrderRefundReason;
    /**
     * 
     * @type {OrderRefundResponsibility}
     * @memberof OrderRefundBody
     */
    responsibility?: OrderRefundResponsibility;
    /**
     * 
     * @type {string}
     * @memberof OrderRefundBody
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundBody
     */
    fiat?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundBody
     */
    fuel?: number;
    /**
     * USD of LootShop credit to restore to the user's ledger. Admin-specified so a partial refund doesn't restore the full applied amount. Defaults to 0 (no restore) when omitted.
     * @type {number}
     * @memberof OrderRefundBody
     */
    lootShopCredit?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundBody
     */
    rewardsClawback?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundBody
     */
    responsiblePartyAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundBody
     */
    transferReverseAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefundBody
     */
    discountNullify?: boolean;
}



/**
 * Check if a given object implements the OrderRefundBody interface.
 */
export function instanceOfOrderRefundBody(value: object): value is OrderRefundBody {
    return true;
}

export function OrderRefundBodyFromJSON(json: any): OrderRefundBody {
    return OrderRefundBodyFromJSONTyped(json, false);
}

export function OrderRefundBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderRefundBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : OrderRefundReasonFromJSON(json['reason']),
        'responsibility': json['responsibility'] == null ? undefined : OrderRefundResponsibilityFromJSON(json['responsibility']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'fiat': json['fiat'] == null ? undefined : json['fiat'],
        'fuel': json['fuel'] == null ? undefined : json['fuel'],
        'lootShopCredit': json['lootShopCredit'] == null ? undefined : json['lootShopCredit'],
        'rewardsClawback': json['rewardsClawback'] == null ? undefined : json['rewardsClawback'],
        'responsiblePartyAmount': json['responsiblePartyAmount'] == null ? undefined : json['responsiblePartyAmount'],
        'transferReverseAmount': json['transferReverseAmount'] == null ? undefined : json['transferReverseAmount'],
        'discountNullify': json['discountNullify'] == null ? undefined : json['discountNullify'],
    };
}

export function OrderRefundBodyToJSON(json: any): OrderRefundBody {
    return OrderRefundBodyToJSONTyped(json, false);
}

export function OrderRefundBodyToJSONTyped(value?: OrderRefundBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': OrderRefundReasonToJSON(value['reason']),
        'responsibility': OrderRefundResponsibilityToJSON(value['responsibility']),
        'notes': value['notes'],
        'fiat': value['fiat'],
        'fuel': value['fuel'],
        'lootShopCredit': value['lootShopCredit'],
        'rewardsClawback': value['rewardsClawback'],
        'responsiblePartyAmount': value['responsiblePartyAmount'],
        'transferReverseAmount': value['transferReverseAmount'],
        'discountNullify': value['discountNullify'],
    };
}

